(function () {
  var root = document.querySelector(".ss-refund");
  if (!root) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var options = root.querySelectorAll(".ss-refund__option");
  var panels = root.querySelectorAll(".ss-refund__form-panel");
  var backBtn = root.querySelector(".ss-refund__back");
  var formsWrap = root.querySelector(".ss-refund__forms");

  function showPanel(method) {
    options.forEach(function (btn) {
      var active = btn.dataset.method === method;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });

    panels.forEach(function (panel) {
      var show = panel.dataset.method === method;
      panel.classList.toggle("is-visible", show);
      panel.hidden = !show;
    });

    if (formsWrap) {
      formsWrap.hidden = false;
      if (!reducedMotion) {
        formsWrap.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }

  function resetSelection() {
    options.forEach(function (btn) {
      btn.classList.remove("is-active");
      btn.setAttribute("aria-selected", "false");
    });
    panels.forEach(function (panel) {
      panel.classList.remove("is-visible");
      panel.hidden = true;
    });
    if (formsWrap) formsWrap.hidden = true;
  }

  options.forEach(function (btn) {
    btn.addEventListener("click", function () {
      showPanel(btn.dataset.method);
    });
  });

  if (backBtn) {
    backBtn.addEventListener("click", resetSelection);
  }

  var reveal = root.querySelectorAll(".ss-refund__reveal");
  if (reducedMotion) {
    reveal.forEach(function (el) {
      el.classList.add("is-visible");
    });
  } else {
    requestAnimationFrame(function () {
      reveal.forEach(function (el, i) {
        setTimeout(function () {
          el.classList.add("is-visible");
        }, i * 80);
      });
    });
  }
})();
